import 'antd/lib/checkbox/style';
//# sourceMappingURL=index.js.map